type Rect = { maxX: number; maxY: number; minX: number; minY: number };

/**
 * Determines if two rectangles intersect.
 */

function doRectanglesIntersect(rectA: Rect, rectB: Rect): boolean {
  const aboveB = rectA.minY > rectB.maxY;
  const belowB = rectA.maxY < rectB.minY;
  const leftOfB = rectA.maxX < rectB.minX;
  const rightOfB = rectA.minX > rectB.maxX;

  return !(leftOfB || rightOfB || aboveB || belowB);
}

export { doRectanglesIntersect };
export type { Rect };
